var map = {
	"./basquiat.png": 230,
	"./basquiat.webp": 240,
	"./corgi.png": 254,
	"./ecommerce-platform.png": 500,
	"./logo.png": 534,
	"./mental-health.jpg": 56,
	"./portfolio-website.png": 450,
	"./profilePic.jpg": 29,
	"./profilePic2.jpg": 155,
	"./profilePic3.jpg": 670,
	"./rothko.png": 931,
	"./tennis-coaching.jpg": 182,
	"./yoga-fitness.jpg": 99
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 290;